module.exports = __webpack_public_path__ + "img/2023-33.c99f962e.jpg";